import KollectiveXHR from '../interceptor/KollectiveXHR';
import buildShakaPlugin from './buildShakaPlugin';
import { ShakaPlayer } from '@kollective-frontend/ksdk-api';
import { InterceptBinder } from '../player/utils/InterceptBinder';

type RSRn = Record<string, Record<string, number>>;

/**
 * Bind intercept to shaka instance through hls tech.
 * see: https://shaka-player-demo.appspot.com/docs/api/lib_net_http_xhr_plugin.js.html
 * see: https://shaka-player-demo.appspot.com/docs/api/shaka.net.NetworkingEngine.html#.PluginPriority
 * @param player - shaka player instance
 * @param binder - object with a shouldIntercept function that returns true if
 *    intercept should happen and a getOptions function that returns the
 *    relevant peer manager
 * @returns void
 */
export default (_player: ShakaPlayer, binder: InterceptBinder): void => {
  const { shaka } = window;
  const xhr = () => {
    if (binder.shouldIntercept()) {
      const opts = binder.getOptions() || {};
      return new KollectiveXHR(opts);
    }
    return new window.XMLHttpRequest();
  };
  const HttpXHRPlugin = buildShakaPlugin(xhr);

  const NetworkingEngine = (shaka.net.NetworkingEngine as unknown) as RSRn;
  const registerScheme = shaka.net.NetworkingEngine.registerScheme;
  const APPLICATION: number = NetworkingEngine.PluginPriority.APPLICATION;

  // https://shaka-player-demo.appspot.com/docs/api/shaka.net.NetworkingEngine.html#.PluginPriority
  // APPLICATION is the highest priority
  registerScheme('http', HttpXHRPlugin, APPLICATION);
  registerScheme('https', HttpXHRPlugin, APPLICATION);
};
